import React, { useState } from 'react';
import { Form, Switch, Spin, Input, Tooltip, Select, Row, Col, Button, Upload, Icon, notification, InputNumber } from 'antd';
import { addCouponItem, getStoresList, postTag } from '../../modules/Api';
import moment from 'moment-jalaali';
import { uploadCodeFile, singleCouponItem, getCouponContent, submitEmailSubscription, getSingleBrand } from '../../modules/Api';
import history from '../../modules/History';
import DatePicker from '../../components/DatePicker';
import SitemapChangeFreqInput from '../../components/SitemapChangeFreqInput.js';
import { number } from 'prop-types';
import Editor from 'for-editor';
import $ from 'jquery';
import Modal from './modal.js';
import clipboard from './clipboard';
import 'font-awesome/css/font-awesome.min.css';
import './Editor.css'
const EditorToolbar = {
    h1: false,
    h2: true,
    h3: true,
    h4: true,
    h5: true,
    img: false,
    link: true,
    code: false,
    preview: true,
    expand: true,
    /* v0.0.9 */
    undo: true,
    redo: true,
    save: false,
    /* v0.2.3 */
    subfield: true,
    rows:1
}

const FormItem = Form.Item;

function hasErrors(fieldsError) {
    return Object.keys(fieldsError).some(field => fieldsError[field]);
}

class CouponForm extends React.Component {
    constructor() {
        super();
        this.state = {
            types: [],
            currencies: [],
            brands: [],
            filteredStoreKeyword: '',
            is_limited: false,
            is_pre_publish: false,
            is_scoreable: 0,
            hideDetails: true,
            newBrandId: null,
            newExpireDate: null,
            newChannel: null,
            is_lucky: false,
            notif: false,
            loading: false,
            selectedTags: [],
            tags: [],
            tmp: false,
            code_file: null,
            is_unique: false,
            data: {},
            meta_updated : false,
            line_height : {'height':"180px"}
        };
        this.showModal = this.showModal.bind(this);
        this.hideModal = this.hideModal.bind(this);
    
    }
    showModal = () => {

        var coupon_id = this.props.initialData.id;
        if (coupon_id) {
            //edit-page
            singleCouponItem(coupon_id, (res) => {
                if (res) {
                    var data = res.data;
                    var code = data.code;
                    this.setValidUntil(data.valid_until, data.is_expired);
                    this.setCode(this.props.form.getFieldsValue().deal_type, code);
                    this.setFeedback(data.likes, data.dislikes, data.feedback);
                    this.setLogo(data.brand);
                    this.setBrandPageLink(data.brand);
                    this.setBrandIdInModalData(data.brand.id);
                    this.setBrandPageURL(data.brand.href);
                    this.setBrandName(data.brand.name);
                    this.setDataAttributesToCopyBtn(data);
                    this.setDataAttributesToBuyBtn(data);
                    this.setChannel(data);
                    this.setScore(data);
                    this.setDescription();
                    document.getElementById('showModal').style.display = '';
                }
            });
        }
        else {
            //add-page
            this.setCode(this.props.form.getFieldsValue().deal_type, null);
            if (this.props.form.getFieldsValue().brand_id != null) {
                this.setLogo(null);
                this.setBrandPageLink(null);
                this.setBrandIdInModalData(null);
                this.setBrandPageURL(null);
                this.setBrandName(null);
            }
            if (this.props.form.getFieldsValue().is_limited != null) {
                this.setValidUntil(null, null);
            }
            this.setChannel(null);
            this.setScore(null);
            this.setDescription();

            document.getElementById('showModal').style.display = '';
        }

    };
    hideModal = () => {
        document.getElementById('showModal').style.display = 'none';
    };

    setCouponIdInModalData(id) {
        $('div#mainModal').data('coupon-id', id);
    };

    setBrandIdInModalData(id) {
        var brandId = this.state.newBrandId != null ? this.findBrand(this.state.newBrandId).id : id;
        $('div#mainModal').data('brand-id', brandId);
    };

    setBrandName(name) {
        var brand_name = this.state.newBrandId != null ? this.findBrand(this.state.newBrandId).name : name;
        $('#modalBrandName').html(brand_name);
    };

    setDescription() {
        var text = this.props.form.getFieldValue('content');
        getCouponContent(text, this.props.initialData.id,
            function (response) {
                if (response) {
                    $('div#mainModal #modalDescription').html(response);
                }
                else {
                }
            });
        
    }
    modalSubmitSubscriptionButton() {
        var brand_id = $('div#mainModal').data('brand-id');
        var email = $('div#mainModal #modalEmail').val();
        if (brand_id !== undefined) {
            submitEmailSubscription(email, brand_id,
                function (response) {
                    if (response.status == "ok") {
                        $('#modalSubsriptionMessage').html(response.message);
                    } else if (response.status == "error") {
                        $('#modalSubsriptionMessage').removeClass('color-green').addClass('color-pink').html(response.data.email.shift());
                    }
                });
        } else {
            $('#modalSubsriptionMessage').removeClass('color-green').addClass('color-pink').html("ابتدا باید کوپن را ثبت کنید");
        }
    }

    setValidUntil(valid_until, expired) {
        valid_until = { day: 0, hour: 0, minute: 0 }
        // Make all hidden
        $('#mainModal #validUntil').addClass('d-none').removeClass('d-flex');
        $('#mainModal #expired').addClass('d-none');
        $('#mainModal #withoutValidUntil').addClass('d-none');
        $('#modalBuyLink').css('filter', 'none');
        $('#modalCodeSection button').css('filter', 'none');

        if (this.state.newExpireDate != null) {
            //replacing day and month in string - reformat
            var dateArray = this.state.newExpireDate.split("/");
            var tempt = dateArray[0];
            dateArray[0] = dateArray[1]
            dateArray[1] = tempt;
            var newExpireDate = dateArray.join('/');
            valid_until = this.dateDiffrences(newExpireDate);
        }

        if (expired) {
            $('#mainModal #expired').removeClass('d-none');
            $('#modalBuyLink').css('filter', 'grayscale(1)');
            $('#modalCodeSection button').css('filter', 'grayscale(1)');
        } else if (typeof (valid_until) === 'object') {
            $('#mainModal #validUntil').removeClass('d-none').addClass('d-flex');
            this.changeCircleChart('circleChartDay', valid_until.day * .16, valid_until.day); // every three month is a complete circle

            this.changeCircleChart('circleChartHour', valid_until.hour * 2.5, valid_until.hour); // every 24 hours is a complete circle

            this.changeCircleChart('circleChartMinute', valid_until.minute, valid_until.minute); // every 60 minutes is a complete circle
        } else {
            $('#mainModal #withoutValidUntil').removeClass('d-none');
        }
    };

    changeCircleChart(id, stroke, text) {
        $('div#mainModal #' + id + ' .progress').css('stroke-dasharray', Math.round(2.4 * stroke) + ' 225').css('animation', 'progress 1.5s ease-in-out');
        $('div#mainModal #' + id + ' .text-big').html(text);
    };

    setError(message) {
        $('div#mainModal #modalError').html(message);
    };

    setBrandPageURL(href) {
        var url = this.state.newBrandId != null ? this.findBrand(this.state.newBrandId).href : href;
        $('#modalBrandLink').attr('href', url);
        $('#modalBrandLogoURL').attr('href', url);
    }

    setCode(deal_type, code) {
        var DEAL_OFFER = 0;
        var DEAL_CODE = 1;
        var DEAL_WALL = 2;

        if (deal_type == DEAL_CODE) {
            $('div#mainModal #modalCodeSection').removeClass('d-none');
        } else {
            $('div#mainModal #modalCodeSection').addClass('d-none');
        }
    };

    setFeedback(likes, dislikes, feedback) {
        $('div#mainModal #modalLiked').html(likes);
        $('div#mainModal #modalDisliked').html(dislikes);
        this.setLikeAndDislikeBtns(feedback);
    };

    setLikeAndDislikeBtns(feedback) {
        var dislike = $("#modalDislikeButton");
        var like = $("#modalLikeButton");

        if (feedback.type === 'LIKE') {
            dislike.addClass('far').removeClass('fas');
            like.removeClass('far').addClass('fas');
        }

        if (feedback.type === 'DISLIKE') {
            dislike.removeClass('far').addClass('fas');
            like.addClass('far').removeClass('fas');
        }
    };

    increaseLikeOrDislike(type) {
        var dislike = $("#modalDisliked");
        var like = $("#modalLiked");

        if (type === 'LIKE') {
            like.html(parseInt(like.text()) + 1);
        }

        if (type === 'DISLIKE') {
            dislike.html(parseInt(dislike.text()) + 1);
        }
    };

    findBrand(id) {
        const brands = this.state.brands.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));
        return brands.find(item => (item.id == id));
    }

    setLogo(brand) {
        var logo = '';
        var store = brand;
        if (this.state.newBrandId != null) {
            var newBrandId = this.state.newBrandId;
            store = this.findBrand(newBrandId);
            document.getElementById("image").hidden = false;
            document.getElementById("image").src = store.logo;
            logo = store.logo;
        } else {
            logo = store.full_logo;
        }
        if (Object.keys(store).length > 0) {
            var parameters = '?in_svg_frame=1&size=150&title=' + store.name;
            $('div#mainModal #LogoSection img').attr('src', logo + parameters);
            $('div#mainModal #LogoSection svg title').html('کد تخفیف ' + store.name);
        }
    };

    setBrandPageLink(brand) {
        var store = brand;
        var website = '';
        if (this.state.newBrandId != null) {
            store = this.findBrand(this.state.newBrandId)
            website = store.href;
        } else {
            website = brand.href;
        }
        var uri = decodeURI(window.location.href);

        if (uri.replace('https://www.mopon.ir', '') == website) {
            $('div#mainModal .modal-footer').removeClass('d-block').addClass('d-none');
            return;
        }

        $('div#mainModal .modal-footer').addClass('d-block').removeClass('d-none');
        $('div#mainModal .modal-footer a').attr('href', website);
        $('div#mainModal .modal-footer a span').html(store.name);
    };

    setDataAttributesToCopyBtn(data) {
        // refer to setCode
        var DEAL_OFFER = 0;
        var DEAL_CODE = 1;
        var DEAL_WALL = 2;

        if (data.deal_type === DEAL_CODE) {
            $('div#mainModal #modalCodeSection button').data('title', data.title).data('coupon-id', data.mpn_id).data('brand-name', data.brand.name).data('trackable', 'true');
        }
    };

    setDataAttributesToBuyBtn(data) {
        $('div#mainModal #modalBuyLink').data('title', data.title).data('coupon-id', data.mpn_id).data('brand-name', data.brand.name).data('trackable', 'true');
    };

    setChannel(data) {
        var channel = this.props.form.getFieldsValue().channel;
        if (channel == 0) {
            $('div#mainModal #modalSiteCouponSection').removeClass('d-none');
            $('div#mainModal #modalAppCouponSection').addClass('d-none');
        } else if (channel == 2) {
            $('div#mainModal #modalSiteCouponSection').addClass('d-none');
            $('div#mainModal #modalAppCouponSection').removeClass('d-none');
        }
    };

    setScore(data) {
        var score = this.props.form.getFieldsValue().score;
        if (this.props.form.getFieldsValue().is_scoreable == true) {
            $('div#mainModal #code_action_btn').addClass('d-none');
            $('div#mainModal #modalBuyLink').addClass('d-none');
            $('div#mainModal #modalCodeSection').addClass('d-none');
            $('div#mainModal #modalError').removeClass('d-none');
            var error = "برای مشاهده این کد نیاز به " + score + " امتیاز دارید. ";
            error = error + "<br>" + "برای این کار اول باید وارد سایت شوید!";
            $("#modalError").html("<div class='alert alert-danger'>" + error + "</div>");
        } else {
            $('div#mainModal #code_action_btn').removeClass('d-none');
            $('div#mainModal #modalBuyLink').removeClass('d-none');
            $('div#mainModal #modalCodeSection').removeClass('d-none');
            $('div#mainModal #modalError').addClass('d-none');
        }
    };

    dateDiffrences(date) {
        var date = (new Date(date).getTime());
        var today = (new Date().getTime());
        var d = Math.abs(date - today) / 1000;
        var r = {};
        var s = { day: 86400, hour: 3600, minute: 60 };

        Object.keys(s).forEach(function (key) {
            r[key] = Math.floor(d / s[key]);
            d -= r[key] * s[key];
        });
        return {
            day: Math.ceil((date - today) / (24 * 60 * 60 * 1000)),
            hour: r.hour,
            minute: r.minute
        }
    }

    componentDidMount() {
        getStoresList(``, res => { this.setState({ brands: res }) });
        this.setState({
            tmp: this.props.initialData.is_limited,
            is_unique: this.props.initialData.is_unique,
            is_lucky: this.props.initialData.is_lucky,
            is_pre_publish: this.props.initialData.is_pre_publish,
            is_scoreable: this.props.initialData.score > 0,
        });
        //adding clipboard.js
        var script = document.createElement('script')
        script.src = clipboard();
        script.class = "external-script"
        document.body.appendChild(script);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ data: nextProps.initialData });

        if (this.state.selectedTags.length === 0 && nextProps.initialData.tag && nextProps.initialData.tag.length > 0) {
            this.setState({ selectedTags: nextProps.initialData.tag });
        }
    }

    handleSubmit = e => {
        e.preventDefault();

        if (this.submittedAt > Date.now() - 500) {
            return;
        }

        this.submittedAt = Date.now();
        // console(this.state)
        this.props.form.validateFields((err, fieldsValue) => {
            if (err) {
                return;
            }
            if (!this.state.is_scoreable) {
                fieldsValue['score'] = null;
            }
            this.props.submit(Object.assign({},
                {
                    tmp: this.state.tmp ? this.state.tmp : this.state.is_limited,
                    code_file: this.state.code_file ? this.state.code_file : null
                },
                fieldsValue, {
                tag: this.state.selectedTags.map(t => t.key),
                meta_updated:this.state.meta_updated
            }
            ));
        })
    }
    getErrorStyles(fieldName) {
        if (this.props.form.getFieldError(fieldName) != undefined) {
            return {
                border: '1px solid red',
            }
        }
       
    }

    setIsLimited = status => {
        this.props.form.setFieldsValue({
            is_limited: status,
        });

        this.setState({ tmp: status });
    }

    setIsPrePublish = status => {
        this.props.form.setFieldsValue({
            is_pre_publish: status,
        });

        this.setState({ is_pre_publish: status });
    }

    setIsScoreable = status => {
        this.props.form.setFieldsValue({
            is_scoreable: status,
        });

        this.setState({ is_scoreable: status });
    }

    setIsLucky = status => {
        this.props.form.setFieldsValue({
            is_lucky: status,
        });

        this.setState({ is_lucky: status });
    }

    get isLimited() {
        return this.props.form.getFieldValue('is_limited');
    }

    get isPrePublish() {
        var is = this.props.form.getFieldValue('is_pre_publish');
        return is;
    }

    get isScoreable() {
        var is = this.props.form.getFieldValue('is_scoreable');
        return is;
    }

    get isLucky() {
        var is = this.props.form.getFieldValue('is_lucky');
        return is;
    }

    get isUnique() {
        // dont use ===
        return this.props.form.getFieldValue('is_unique') == 1;
    }

    get hasCode() {
        // dont use ===
        return this.props.form.getFieldValue('deal_type') == 1;
    }

    fetchTag(keyword) {
        if (!(keyword === null || keyword === undefined || keyword === '')) {
            this.setState({ tags: [{ text: keyword, value: keyword }] });
        }
    }

    commitTags(items) {
        this.setState({ tags: [], selectedTags: items });
        items.forEach(t => {
            postTag({ title: t.label }, id => {
                this.setState({
                    selectedTags: this.state.selectedTags.map(d => {
                        return d.label === t.label ? Object.assign({}, d, { key: id }) : d;
                    })
                });
            });
        });
    }

    brandFilterOption = (input, option) => option.key.includes(input);

    updateHeight(text){
        var size_height = 0
        if(text==undefined){
            return;
        }
        if(text.length<300){
            this.setState({line_height:{ 'height':'180px'} })
        }else{
            size_height = (Math.ceil(text.length/50)*25)
            this.setState({ line_height:{ 'height': size_height.toString()+'px'}})
        }
        let lncount = text.split(/\r?\n/).length
        size_height = size_height + (lncount*25)+30
        if(size_height<180){
            size_height = 180;
        }
        this.setState({ line_height:{ 'height': size_height.toString()+'px'}})

    }
    render() {
        const brands = this.state.brands.filter(s => s.name.startsWith(this.state.filteredStoreKeyword));
        const { hideDetails , line_height } = this.state;
        if((this.props.initialData.content!=null || this.props.initialData.content != "") && this.state.data.content == null ){
            this.updateHeight(this.props.initialData.content)
        }
        const textEditorStyle = {...this.getErrorStyles('content'),...line_height};
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        };
        const { getFieldDecorator, getFieldsError } = this.props.form;
        return (
            <div style={{ direction: 'rtl' }}>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col span={10} offset={1}>

                            <FormItem
                                {...formItemLayout}
                                label="امتیازی است؟"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('is_scoreable', {
                                    valuePropName: 'checked',
                                    initialValue: this.props.initialData.score ? true : false
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsScoreable} />
                                )}
                            </FormItem>
                            {
                                this.isScoreable ? (<React.Fragment>

                                    <FormItem
                                        {...formItemLayout}
                                        label="امتیاز"
                                        colon={false}>
                                        {getFieldDecorator('score', {
                                            initialValue: this.props.initialData.score,
                                            rules: [{
                                                required: true,
                                                message: "عدد امتیاز را مشخص کنید",
                                            }],
                                        })(
                                            <InputNumber />
                                        )}
                                    </FormItem>
                                </React.Fragment>) : ''
                            }

                            <FormItem
                                {...formItemLayout}
                                label="پیش نویس است؟"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('is_pre_publish', {
                                    valuePropName: 'checked',
                                    initialValue: this.props.initialData.publish_date ? false : (this.props.initialData.id && !this.props.initialData.publish_date ? true : false)
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsPrePublish} />
                                )}
                            </FormItem>

                            {
                                !this.isPrePublish && (<React.Fragment>
                                    <FormItem
                                        {...formItemLayout}
                                        label="تاریخ انتشار"
                                        style={{ direction: 'ltr' }}
                                        colon={false}>
                                        {getFieldDecorator('publish_date',
                                            {
                                                initialValue: moment(this.props.initialData.publish_date ? this.props.initialData.publish_date : Date.now()),
                                                rules: [{
                                                    type: 'object',
                                                    required: true,
                                                    message: 'انتخاب تاریخ انتشار ضروری است'
                                                }]
                                            }
                                        )(
                                            <DatePicker isGregorian={false} inputJalaaliFormat="jYYYY-jMM-jDD HH:mm" time_picker_props={{ showAMPM: false }} />
                                        )}
                                    </FormItem>
                                </React.Fragment>)
                            }

                            <FormItem
                                {...formItemLayout}
                                label="مدت زمان محدود است ؟ (فقط منبع رسمی)"
                                colon={false}>
                                {getFieldDecorator('is_limited', {
                                    valuePropName: 'checked',
                                    initialValue: this.props.initialData.is_limited === 1 || this.props.initialData.is_limited === true
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsLimited} />
                                )}
                            </FormItem>

                            {
                                this.isLimited && (<React.Fragment>
                                    <FormItem
                                        {...formItemLayout}
                                        label="تاریخ انقضا"
                                        style={{ direction: 'ltr' }}
                                        colon={false}>
                                        {getFieldDecorator('expiration_date',
                                            {
                                                initialValue: moment(this.props.initialData.expiration_date),
                                                rules: [{ type: 'object', required: false, message: '' }]
                                            }
                                        )(
                                            <DatePicker isGregorian={false} inputJalaaliFormat="jYYYY-jMM-jDD HH:mm" time_picker_props={{ showAMPM: false }} onChange={(date) => {
                                                this.state.newExpireDate = new Date(date).toLocaleDateString('fr-FR');
                                            }} />
                                        )}
                                    </FormItem>

                                    <Tooltip title="اگر کوپن منقضی شده است تاریخ انقضا را یک تاریخ قبل از تاریخ امروز انتخاب نمایید .">
                                        <span style={{ color: 'green' }}> *نکته!</span>
                                    </Tooltip>
                                </React.Fragment>)
                            }

                            <FormItem
                                {...formItemLayout}
                                label="تگ ها (اسم رویداد)"
                                colon={false}>
                                {getFieldDecorator('tag', {
                                    initialValue: this.props.initialData.tag,
                                    rules: [
                                    ],
                                })(
                                    <Select
                                        mode="multiple"
                                        labelInValue
                                        placeholder="انتخاب تگ"
                                        notFoundContent={this.state.loading ? <Spin size="small" /> : null}
                                        filterOption={false}
                                        onSearch={this.fetchTag.bind(this)}
                                        onChange={this.commitTags.bind(this)}
                                        style={{ width: '200px' }}>
                                        {this.state.tags.map(d => <Select.Option key={d.value}>{d.text}</Select.Option>)}
                                    </Select>
                                )}
                            </FormItem>

                        </Col>

                        <Col span={11} offset={1}>
                            <FormItem
                                {...formItemLayout}
                                label="موارد جزئی"
                                colon={false}>
                                {getFieldDecorator('hideDetails', {
                                    valuePropName: 'checked',
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={() => this.setState({ hideDetails: !hideDetails })} />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="برای گردونه شانس است؟"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('is_lucky', {
                                    valuePropName: 'checked',
                                    initialValue: this.props.initialData.is_lucky ? true : false
                                })(
                                    <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={this.setIsLucky} />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="کانال انتشار"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('channel', {
                                    initialValue: (this.props.initialData.channel || 0) + '',
                                    rules: [],
                                })(
                                    <Select placeholder="کانال انتشار را انتخاب نمایید..." style={{ width: '200px' }} onChange={v => this.state.newChannel = v} >
                                        <Select.Option value="0">همه</Select.Option>
                                        <Select.Option value="2">اپلیکیشن</Select.Option>
                                        <Select.Option value="4">ثبت نامی</Select.Option>
                                    </Select>
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="نوع"
                                colon={false}>
                                {getFieldDecorator('deal_type', {
                                    initialValue: this.props.initialData.deal_type !== undefined ? this.props.initialData.deal_type + '' : null,
                                    rules: [
                                        { required: true, message: 'نوع کوپن را انتخاب نمایید!' },
                                    ],
                                })(
                                    <Select placeholder="نوع کوپن را انتخاب نمایید..." style={{ width: '200px' }} onChange={v => this.props.form.setFieldsValue({ deal_type: v })}>
                                        <Select.Option value="1">کد تخفیف</Select.Option>
                                        <Select.Option value="0">پیشنهاد تخفیف دار</Select.Option>
                                    </Select>
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="فروشگاه"
                                colon={false}>
                                {getFieldDecorator('brand_id', {
                                    initialValue: this.props.initialData.brand_id ? this.props.initialData.brand_id + '' : null,
                                    rules: [
                                        { required: true, message: 'فروشگاه را انتخاب نمایید' },
                                    ],
                                })(
                                    <Select placeholder="انتخاب فروشگاه" filterOption={this.brandFilterOption} style={{ width: '200px' }} onChange={e => { this.state.newBrandId = e; this.setLogo(null) }} showSearch={true}>
                                        {brands.map(s => <Select.Option value={s.id.toString()} key={`ss__${s.id}__${s.name}`} >{s.name} ({s.id})</Select.Option>)}
                                    </Select>
                                )}
                                <img id="image" src="" hidden={true} height="60" width="60" />
                            </FormItem>


                            <FormItem
                                {...formItemLayout}
                                label={this.isLucky ? "عدد تخفیف" : "عنوان (میزان تخفیف، اسم فروشگاه، اولین خرید، محصول خاص، شهر و اپلیکیشن)"}
                                colon={false}>
                                {getFieldDecorator('title', {
                                    initialValue: this.props.initialData.title,
                                    rules: [{
                                        required: true, message: 'عنوان کوپن را وارد نمایید!',
                                    }],
                                })(
                                    <Input />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="عنوان متا"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('meta_title', {
                                    initialValue: this.props.initialData.meta_title,
                                    rules: [
                                        {
                                            required: false
                                        }
                                    ],
                                })(
                                    <Input onChange={v => this.setState({meta_updated:true})} />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label={this.isLucky ? "توضیحات تخفیف" : `توضیحات (میزان تخفیف، حداقل خرید، سقف تخفیف، اولین خرید، محصول خاص، شهر، اپلیکیشن، توضیح خود فروشگاه، توضیح لینک خرید) `}
                                colon={false}>
                                {getFieldDecorator('content', {
                                    initialValue: this.props.initialData.content,
                                    rules: [{
                                        required: true, message: 'توضیحات کوپن را وارد نمایید!',
                                    }],
                                })(
                                    this.isLucky ? <Input /> : <Editor  style={textEditorStyle} placeholder="توضیحات" onChange={v => this.updateHeight(v)}  toolbar={EditorToolbar} />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="توضیحات متا"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('meta_description', {
                                    initialValue: this.props.initialData.meta_description,
                                    rules: [
                                        {
                                            required: false
                                        }
                                    ],
                                })(
                                    <Input.TextArea />
                                )}
                            </FormItem>

                            <FormItem
                                {...formItemLayout}
                                label="توضیحات اضافی"
                                hidden={hideDetails}
                                colon={false}>
                                {getFieldDecorator('additional_description', {
                                    initialValue: this.props.initialData.additional_description,
                                    rules: [
                                        {
                                            required: false
                                        }
                                    ],
                                })(
                                    <Editor style={this.getErrorStyles('additional_description')} placeholder="توضیحات کوتاه" toolbar={EditorToolbar} />
                                )}
                            </FormItem>
                            <FormItem
                                {...formItemLayout}
                                label="لینک"
                                colon={false}>
                                {getFieldDecorator('link', {
                                    initialValue: this.props.initialData.link,
                                    rules: [
                                        {
                                            required: true, message: 'لینک کوپن صفحه فروشگاه را وارد نمایید!',
                                        },
                                        {
                                            type: "url",
                                            message: "لینک وارد شده دارای فرمت مناسب نیست و یا معتبر نمیباشد!"
                                        }
                                    ],
                                })(
                                    <Input />
                                )}
                            </FormItem>

                            {
                                this.hasCode && <FormItem
                                    {...formItemLayout}
                                    label="نوع کد"
                                    colon={false}>
                                    {getFieldDecorator('is_unique', {
                                        initialValue: this.props.initialData.is_unique ? '1' : '0',
                                        rules: []
                                    })(
                                        <Select placeholder="نوع کد را انتخاب نمایید." style={{ width: '200px' }} onChange={v => this.props.form.setFieldsValue({ is_unique: v })}>
                                            <Select.Option value="0">کد عمومی</Select.Option>
                                            <Select.Option value="1">کد یکتا</Select.Option>
                                        </Select>
                                    )}
                                </FormItem>
                            }

                            {
                                this.hasCode && !this.isUnique && <FormItem
                                    {...formItemLayout}
                                    label="کد"
                                    colon={false}>
                                    {getFieldDecorator('code', {
                                        initialValue: this.props.initialData.code,
                                        rules: this.isLucky ? [{
                                            required: true, message: 'کد تخفیف برای گردونه اجباری است!',
                                        }] : [],
                                    })(
                                        <Input.TextArea style={{ direction: 'ltr' }} />
                                    )}
                                </FormItem>
                            }

                            {
                                this.hasCode && this.isUnique && <FormItem
                                    {...formItemLayout}
                                    label="کد تخفیف به صورت فایل"
                                    extra="فایل تا حداکثر ۲ مگابایت با پسوند .txt"
                                    colon={false}>
                                    {getFieldDecorator('upload', {
                                        valuePropName: '.txt',
                                        getValueFromEvent: this.normFile,
                                    })(
                                        <Upload
                                            name="code_file"
                                            action=""
                                            customRequest={() => { }}
                                            accept=".txt"
                                            onChange={f => {
                                                document.getElementById('file_upload_loader').style.display = 'block'
                                                uploadCodeFile(f, (src) => {
                                                    this.setState({ code_file: src });
                                                    if (src) {
                                                        notification.open({
                                                            message: `.فایل آپلود شد`
                                                        });
                                                    }

                                                    setTimeout(() => {
                                                        document.getElementById('file_upload_loader').style.display = 'none'
                                                    }, 2000)
                                                }
                                                )
                                            }}
                                            listType="text"
                                            showUploadList={false}>
                                            <Button>
                                                <Icon type="upload" /> انتخاب فایل
                                            </Button>
                                        </Upload>
                                    )}
                                    {<div id="file_upload_loader" style={{ marginRight: '10px', display: 'none' }}><Spin size="small" style={{ marginTop: '5px' }} /> در حال آپلود</div>}
                                </FormItem>
                            }

                            <Row>
                                <Col span={12}>
                                    <FormItem
                                        {...formItemLayout}
                                        label="کوپن همکاری"
                                        colon={false}>
                                        {getFieldDecorator('plan', {
                                            valuePropName: 'checked',
                                            initialValue: this.props.initialData.plan === 1 || this.props.initialData.plan === true,
                                            rules: []
                                        })(
                                            <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={v => { this.setState({ plan: v }) }} />
                                        )}

                                    </FormItem>
                                </Col>

                                <Col span={12}>
                                    <FormItem
                                        {...formItemLayout}
                                        label="ارسال نوتیف (شهر و اولین خرید نباشد)"
                                        colon={false}>
                                        {getFieldDecorator('notif', {
                                            valuePropName: 'checked',
                                            initialValue: false,
                                            rules: []
                                        })(
                                            <Switch checkedChildren="بله" unCheckedChildren="خیر" onChange={v => { this.setState({ notif: v }) }} />
                                        )}

                                    </FormItem>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    {SitemapChangeFreqInput(this.props.initialData.sitemap_change_freq, getFieldDecorator, formItemLayout, hideDetails)}

                                    <FormItem
                                        {...formItemLayout}
                                        label="اولویت نقشه سایت"
                                        hidden={hideDetails}
                                        colon={false}>
                                        {getFieldDecorator('sitemap_priority', {
                                            initialValue: this.props.initialData.sitemap_priority
                                        })(
                                            <Input />
                                        )}
                                    </FormItem>

                                </Col>
                            </Row>
                        </Col>

                    </Row>

                    <FormItem>
                        <div className="btn-container">
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={hasErrors(getFieldsError()) || this.props.submitted}
                            >
                                {this.props.submitted ? 'منتظر بمانید' : ' ثبت'}
                            </Button>
                            <Button type='button' onClick={this.showModal}> پیش نمایش  </Button>

                            {
                                this.props.initialData.id &&
                                <Button type="secondary" onClick={() => history.item.push(`/history/coupon/${this.props.initialData.id}`)}>تاریخچه تغییرات</Button>
                            }
                        </div>
                    </FormItem>
                </Form>
                <div id="showModal" style={{ display: 'none' }}>
                    <Modal onClose={this.hideModal} inputData={this.props.form.getFieldsValue()} modalSubmitSubscriptionButton={this.modalSubmitSubscriptionButton}></Modal>
                </div>
            </div>
        )
    }
}
CouponForm.defaultValue = {
    initialData: {}
}

export default Form.create({ name: 'horizontal_login' })(CouponForm);



// WEBPACK FOOTER //
// ./src/containers/Coupons/form.js